import { Separator } from '@nesso/ui/primitives/separator';

export function AuthOrDivider() {
    return (
        <div className="flex items-center gap-3">
            <Separator className="flex-1" />
            <span className="text-sm text-muted-foreground">or</span>
            <Separator className="flex-1" />
        </div>
    );
}
